import { PageTabsRoot, PageTabsList, PageTabsTab, PageTabsPanel } from './page-tabs-primitives';

const PageTabs = {
  List: PageTabsList,
  Panel: PageTabsPanel,
  Root: PageTabsRoot,
  Tab: PageTabsTab,
};

export { PageTabs };
